import { Directive, OnInit } from "@angular/core";
import { AppBarTitleService, parseNumber, SsoAccountFacade, SsoAccountData, UserMessageType, UserMessageSubjects } from "common";
import * as _ from "lodash";
import { DismissableBaseService } from "common";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { EntityFacade } from "../entity/domain/+state/entity.facade";
import { ActivatedRoute } from "@angular/router";

@UntilDestroy()
@Directive()
export abstract class ReferralCodeBaseComponent<T> implements OnInit {
  referSubject = UserMessageSubjects.EarnUpTo10000;
  customerId: number;
  entityId: number;
  notificationData: any;
  protected _searchCondition: any;

  constructor(
    private appBarTitleService: AppBarTitleService,
    protected notificationDismissableService: DismissableBaseService<T>,
    private entityFacade: EntityFacade,
    private route: ActivatedRoute,
    private ssoAccountFacade: SsoAccountFacade
  ) {}

  ngOnInit() {
    this.appBarTitleService.title = UserMessageSubjects.EarnUpTo10000;
    this.initCurrentSsoAccount();
    this.initEntity();
  }

  private initCurrentSsoAccount(): void {
    this.ssoAccountFacade
      .getCurrentSsoAccount$()
      .pipe(untilDestroyed(this))
      .subscribe((ssoAccount: SsoAccountData) => {
        this.customerId = ssoAccount.id;
      });
  }

  private initEntity() {
    this.entityFacade
      .getEntity$(parseNumber(this.route.snapshot.queryParams.companyId))
      .pipe(untilDestroyed(this))
      .subscribe((entity) => {
        this.entityId = entity.id;
        this.initNotificationData(entity.id);
      });
  }

  private initNotificationData(entityId: number) {
    this.notificationDismissableService
      .query(entityId, UserMessageType.OnScreen)
      .pipe(untilDestroyed(this))
      .subscribe((data) => {
        const object = _.find(data, this._searchCondition);
        if (object) {
          this.notificationData = object;
        }
      });
  }

  dismiss(event: any) {
    if (this.notificationData) {
      this.notificationDismissableService
        .update(
          this.customerId,
          this.entityId,
          this.notificationData,
          event.checked
        )
        .pipe(untilDestroyed(this))
        .subscribe();
    }
  }
}
